import { IconButton, Icon, Tooltip, iconWeight } from '@nula/core-ui';
import { SidePanel } from '@/components/side-panel/side-panel';
import { useUIStore } from '@/stores/use-ui-store';
import { sessionOpenTab } from '@/session/session-bridge';
import { ConversationHistoryList } from './conversation-history-list';
import styles from './assistant-history-panel.module.css';

/**
 * Right-side panel listing the user's saved assistant conversations.
 *
 * Mirrors the version-history / comments side panels: a SidePanel-wrapped
 * view mounted as a Drawer in app-overlays.tsx. Opens over the assistant chat
 * drawer at the right edge; selecting a conversation loads it into the chat
 * and closes this panel (open-over model — see ConversationHistoryList's
 * onAfterSelect).
 *
 * The "New chat" action mints a conversationId at click time and opens a new
 * conversation tab (§7.4). This panel is mounted outside the provider tree
 * so it cannot use useAssistantChatContext; sessionOpenTab is the correct
 * mechanism for creating a new conversation tab from any location.
 */
export function AssistantHistoryPanel() {
  const close = () => useUIStore.getState().setAssistantHistoryOpen(false);
  const newChat = () => {
    sessionOpenTab(crypto.randomUUID(), 'conversation');
    close();
  };
  return (
    <SidePanel
      title="Conversations"
      icon="history"
      onClose={close}
      bodyClassName={styles.flushBody}
      data-assistant-surface
      titleExtra={
        <Tooltip title="New chat" placement="bottom">
          <IconButton
            size="sm"
            aria-label="New chat"
            onClick={newChat}
            className={styles.newChatBtn}
          >
            <Icon name="edit_square" size={16} weight={iconWeight.light} />
          </IconButton>
        </Tooltip>
      }
    >
      <ConversationHistoryList onAfterSelect={close} />
    </SidePanel>
  );
}
